import { Money } from "../money/money.js";
/**
 * The plans every enterprise uses Civentia on (ADR 0023, `docs/legal/plans.en.md`): what each allows and its price,
 * in SGD excluding GST. A limit is null where the plan sets no fixed one. An enterprise without a plan of its own is on
 * Starter.
 */
export const PLAN_KEYS = ["starter", "growth", "scale"];
export const BILLING_PERIODS = ["monthly", "yearly"];
const GB = 1_000_000_000;
const sgd = (minor) => Money.of(minor, "SGD");
export const PLANS = {
    starter: {
        key: "starter",
        limits: { members: 10, liveListings: 20, storageBytes: 5 * GB, customRoles: false },
        price: { monthly: sgd(0n), yearly: sgd(0n) },
    },
    growth: {
        key: "growth",
        limits: { members: 50, liveListings: 300, storageBytes: 100 * GB, customRoles: true },
        price: { monthly: sgd(9900n), yearly: sgd(99000n) },
    },
    scale: {
        key: "scale",
        limits: { members: 200, liveListings: null, storageBytes: 1_000 * GB, customRoles: true },
        price: { monthly: sgd(29900n), yearly: sgd(299000n) },
    },
};
/** Starter costs nothing, so it has no billing period; every other plan has one. */
export const isFree = (plan) => PLANS[plan].price.monthly.isZero();
/** How much of a limit is used: within it, at it, or above it (as after a downgrade); never above a null limit. */
export function usageAgainst(limit, used) {
    if (limit === null || used < limit)
        return "within";
    return used === limit ? "at" : "above";
}
//# sourceMappingURL=plans.js.map